import { makeStyles } from '../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: Object.assign(Object.assign({}, theme.typography.body2), { padding: `${theme.spacing(2.5)} ${theme.spacing(3)}` }),
    dividers: ({ topDivider, bottomDivider }) => ({
        borderTop: `${!topDivider ? 'none' : undefined}`,
        borderBottom: `${!bottomDivider ? 'none' : undefined}`,
    }),
}));
//# sourceMappingURL=DialogContent.styles.js.map